module.exports = __webpack_public_path__ + "static/img/zfb_hui.b6e0dcef.png";